import React from 'react'
import logo from './assets/img/neo_logo.png'
import wifi_img from './assets/img/neo_wifi.png'
import Login from './components/Login'
import Success from './components/Success'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

function App() {

  return (
    <div className="flex flex-col w-screen relative">
      <div className='flex flex-row justify-between h-20 w-full'>
        <img className='h-20' src={logo} alt="neosystem logo" />
        <img className='h-20 justify-self-end' src={wifi_img} alt="wifi logo" />
      </div>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/guest/s/:site/" element={<Login />} />
          <Route path="/success" element={<Success />} />
        </Routes>
      </Router>
      <div className="fixed bottom-0 w-full text-center bg-blue-400 text-white uppercase text-sm p-2"> Neosystem 2022</div>
    </div>
  );
}

export default App;